// Single source of truth for "mobile?" — used by Shell + per-route layouts.
// Proton's "small" breakpoint (680px, lib/_config.scss $breakpoints-product),
// the same threshold the Proton CSS uses to switch to the off-canvas sidebar,
// so JS layout decisions and CSS never disagree. Falls back to false in SSR.

import { useEffect, useState } from "react";

const MOBILE_MEDIA = "(max-width: 42.5em)";

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(MOBILE_MEDIA).matches;
  });
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MEDIA);
    const handler = (e: MediaQueryListEvent) => setMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return mobile;
}
